import { ADD_CHECK_LIST, ADD_SYSTEM, ADD_SYSTEM_MEASUREMENT, DELETE_SYSTEM, EDIT_SYSTEM, GET_CHECK_LIST_BY_SYSTEM_ID, GET_SYSTEMS_BY_ORDER_ID, GET_SYSTEMS_CHECK_LIST_MOBILE, GET_SYSTEMS_CHECK_LIST_TABLET, GET_SYSTEMS_FOR_ACCORDION, MOVE_SYSTEM_ROW, REMOVE_SYSTEM_FROM_SYSTEMS_OPENING_PATH, SELECTED_SYSTEM_BY_SYSTEM_ID, SET_SYSTEMS_FOR_ACCORDION, SET_SYSTEM_FOR_SYSTEMS_OPENING_PATH, SHOW_SYSTEMS_POP_UP, UPDATE_SYSTEM_CHECKLIST, RESET_SYSTEMS_FOR_ACCORDION } from "../../constants/customer/systemConstants";
import { getOrderSystemsList, updateNewSystemCheckListSection } from "../../functions/api/orders";
import * as types from "../types";

function transformCustomerDataToAccordionTreeResponse(systems) {
    const result = [];
    const systemsByLayer = {};

    for (const system of systems) {
        const { layer, parent_system_id } = system;

        const layerKey = String(layer);
        const parentKey = parent_system_id
            ? parent_system_id.toString()
            : "null";

        if (!systemsByLayer[layerKey]) {
            systemsByLayer[layerKey] = {};
        }

        if (!systemsByLayer[layerKey][parentKey]) {
            systemsByLayer[layerKey][parentKey] = [];
        }

        systemsByLayer[layerKey][parentKey].push(system);
    }

    for (const layerKey of Object.keys(systemsByLayer)) {
        const systemLayerObj = {
            layer: Number(layerKey),
            systems: []
        };

        for (const parentKey of Object.keys(systemsByLayer[layerKey])) {
            systemLayerObj.systems.push({
                parent_system_id: parentKey === "null" ? null : parentKey,
                systems: systemsByLayer[layerKey][parentKey]
            });
        }

        result.push(systemLayerObj);
    }

    return result;
}

export const updateSystemChecklistLocal = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SYSTEM_CHECKLIST, payload: data })
    }
}
export const updateSystemChecklistServer = (data) => {
    return async (dispatch) => {
        const response = await updateNewSystemCheckListSection(data)

        if (data.onSuccess) {
            data.onSuccess(response);
        }

    }
}

export const systemActionsCreator = {
    getSystemsCheckListMobile: () => ({ type: GET_SYSTEMS_CHECK_LIST_MOBILE }),
    getSystemsCheckListTablet: () => ({ type: GET_SYSTEMS_CHECK_LIST_TABLET }),
    getSystemsByOrderId: (orderId, processId = '') => {
        return async (dispatch) => {
            dispatch({ type: RESET_SYSTEMS_FOR_ACCORDION })
            const response = await getOrderSystemsList(orderId, processId);
            dispatch({ type: GET_SYSTEMS_BY_ORDER_ID, payload: response.result })
            dispatch({ type: SET_SYSTEMS_FOR_ACCORDION, payload: { response, processId } })
        }
    },
    getSystemsByCustomer: (customer) => {

        return async (dispatch) => {
            try {
                const response = transformCustomerDataToAccordionTreeResponse(customer.systems);

                dispatch({ type: GET_SYSTEMS_BY_ORDER_ID, payload: response })
                dispatch({ type: SET_SYSTEMS_FOR_ACCORDION, payload: { response: { result: response } } })
            } catch (err) {
                console.log("Error", err);
            }

        }
    },

    getSystemsForAccordion: () => {
        return ({ type: GET_SYSTEMS_FOR_ACCORDION })
    },
    addSystem: (system) => ({
        type: ADD_SYSTEM, payload: system
    }),
    selectedSystemBySystemId: (selectedBy) => {
        return ({ type: SELECTED_SYSTEM_BY_SYSTEM_ID, payload: selectedBy })
    },
    editSystem: (system) => ({
        type: EDIT_SYSTEM, payload: system
    }),
    deleteSystem: (deleteBy) => {
        return ({
            type: DELETE_SYSTEM, payload: deleteBy
        })
    },
    getCheckListBySystemId: (systemId) => {
        return ({
            type: GET_CHECK_LIST_BY_SYSTEM_ID, payload: systemId
        })
    },
    moveSystemRow: (currentRowInfo) => ({ type: MOVE_SYSTEM_ROW, payload: currentRowInfo }),
    addCheckList: () => ({ type: ADD_CHECK_LIST }),
    setSystemForAccordion: () => {
        return ({
            type: SET_SYSTEMS_FOR_ACCORDION,
        })
    },
    setSystemsOpeningPath: (system) => ({ type: SET_SYSTEM_FOR_SYSTEMS_OPENING_PATH, payload: system }),
    removeSystemFromOpeningPath: (system) => ({ type: REMOVE_SYSTEM_FROM_SYSTEMS_OPENING_PATH, payload: system }),

    addSystemMeasurement: (measurement) => ({ type: ADD_SYSTEM_MEASUREMENT, payload: measurement }),


    showSystemsPopup: (boolean) => ({ type: SHOW_SYSTEMS_POP_UP, payload: boolean }),



}